import {formatDate}  from './format_date';

let utils = {
    formatDate
}

export { utils }